import { type ChangeEvent, createContext, type FC, type MouseEvent, type ReactElement, useState } from 'react';
import { usePagination } from '../content/hooks';
import type { ListMedia, MediaSortingFields, Order } from '../models';

interface IRefMaterialsContext {
  shouldUpdate: boolean;
  toggleShouldUpdate: () => void;
  data: ListMedia[];
  setData: (val: ListMedia[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: MediaSortingFields;
  setOrderBy: (val: MediaSortingFields) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleRequestSort: (_event: MouseEvent, property: MediaSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const RefMaterialsContext = createContext<IRefMaterialsContext>({} as IRefMaterialsContext);

export const RefMaterialsProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const toggleShouldUpdate = (): void => setShouldUpdate(!shouldUpdate);

  const {
    page,
    setPage,
    limit,
    setLimit,
    count,
    setCount,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    handlePageChange,
    handleLimitChange,
    handleRequestSort
  } = usePagination<MediaSortingFields>(toggleShouldUpdate, 'createdAt', 'asc');

  const [data, setData] = useState<ListMedia[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <RefMaterialsContext.Provider
      value={{
        shouldUpdate,
        toggleShouldUpdate,
        data,
        setData,
        page,
        setPage,
        limit,
        setLimit,
        loading,
        setLoading,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        handlePageChange,
        handleLimitChange,
        handleRequestSort
      }}
    >
      {children}
    </RefMaterialsContext.Provider>
  );
};
